/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import CalculatorDetailsItem from 'kentico-blocks/Calculator/CalculatorDetailsItem';
import {
  PaddedBottomRow,
  PaddedTopRow,
} from 'kentico-blocks/Calculator/styled';
import FullWidthCalculatorDetailsItem
  from 'kentico-blocks/Calculator/FullWidthCalculatorDetailsItem';

@inject('calculatorStore', 'windowStore')
@observer
class CostOfZoniferoGrid extends Component {
  render() {
    const {
      windowStore,
      calculatorStore,
      data: {
        currency,
        sideInfoOptimisationPeriod,

        estimatedCostOfSensorInstallationPerDesk,
        costOfScreenHardwarePerRoom,
        subscriptionFeePerEmployeeIn5Years,

        numberOfDesksLabel,
        numberOfConferenceRoomsLabel,
        hardwareImplementationCostLabel,
        costOfZoniferoIn5YearsPerspectiveLabel,
        totalOptimisationPerMonthLabel,
        yourReturnOfInvestmentTimeLabel,
        numberOfEmployeesLabel,
      },
    } = this.props;

    return (
      <React.Fragment>
        <PaddedTopRow>
          {/* FIRST ROW */}
          <CalculatorDetailsItem
            calculatorValue={estimatedCostOfSensorInstallationPerDesk}
            unit={currency}
            sign="x"
          />
          <CalculatorDetailsItem
            label={numberOfDesksLabel}
            value={calculatorStore.numberOfDesks.get()}
            sign="+"
          />
          <CalculatorDetailsItem
            label={numberOfConferenceRoomsLabel}
            value={calculatorStore.numberOfConferenceRooms.get()}
            sign="x"
          />
          <CalculatorDetailsItem
            calculatorValue={costOfScreenHardwarePerRoom}
            unit={currency}
            sign={windowStore.isOnDesktop ? '=' : ''}
          />
          {windowStore.isOnDesktop
            ? (
              <CalculatorDetailsItem
                label={hardwareImplementationCostLabel}
                value={calculatorStore.hardwareImplementationCost}
                unit={currency}
                valueBold
              />
            ) : (
              <FullWidthCalculatorDetailsItem
                label={hardwareImplementationCostLabel}
                value={calculatorStore.hardwareImplementationCost}
                unit={currency}
                sign="="
                valueBold
              />
            )}

        </PaddedTopRow>
        <PaddedBottomRow>
          {/* SECOND ROW */}
          <CalculatorDetailsItem
            calculatorValue={subscriptionFeePerEmployeeIn5Years}
            unit={currency}
            sign="x"
          />
          <CalculatorDetailsItem
            label={numberOfEmployeesLabel}
            value={calculatorStore.numberOfEmployees.get()}
            sign="+"
          />
          <CalculatorDetailsItem
            label={hardwareImplementationCostLabel}
            value={calculatorStore.hardwareImplementationCost}
            unit={currency}
            sign={windowStore.isOnDesktop ? '=' : ''}
            mobileWidth2x
          />
          {windowStore.isOnDesktop ? (
            <CalculatorDetailsItem
              label={costOfZoniferoIn5YearsPerspectiveLabel}
              value={calculatorStore.costOfZoniferoIn5Years}
              unit={currency}
              labelBold
            />
          ) : (
            <FullWidthCalculatorDetailsItem
              label={costOfZoniferoIn5YearsPerspectiveLabel}
              labelBold
              value={calculatorStore.costOfZoniferoIn5Years}
              unit={currency}
              sign="="
              valueBold
            />
          )}

        </PaddedBottomRow>
        <PaddedTopRow>
          {/* THIRD ROW */}
          <CalculatorDetailsItem
            label={costOfZoniferoIn5YearsPerspectiveLabel}
            value={calculatorStore.costOfZoniferoIn5Years}
            unit={currency}
            sign="/"
            bigSign
            bigUnit
            labelBold
            mobileWidth2x
          />
          <CalculatorDetailsItem
            label={totalOptimisationPerMonthLabel}
            value={calculatorStore.totalOptimisationPerMonth}
            unit={currency}
            sign={windowStore.isOnDesktop ? '=' : ''}
            bigUnit
            labelBold
            mobileWidth2x
          />
          {windowStore.isOnDesktop ? (
            <CalculatorDetailsItem
              label={yourReturnOfInvestmentTimeLabel}
              value={calculatorStore.yourReturnOfInvestmentTime}
              unit={sideInfoOptimisationPeriod}
              valueBold
              labelBold
            />
          ) : (
            <FullWidthCalculatorDetailsItem
              label={yourReturnOfInvestmentTimeLabel}
              value={calculatorStore.yourReturnOfInvestmentTime}
              unit={sideInfoOptimisationPeriod}
              sign="="
              valueBold
            />
          )}
        </PaddedTopRow>
      </React.Fragment>
    );
  }
}

export default CostOfZoniferoGrid;



// WEBPACK FOOTER //
// ./src/kentico-blocks/Calculator/CalculatorDetailsView/CostOfZoniferoGrid/index.jsx